import { FC, ReactElement } from 'react';
import styles from './product-short-info.module.scss';
import classNames from 'classnames';
import { ShortInfoRentalStationSelectProps } from './short-info-rentalstation-select';
import { ProductPriceProps } from './../product-price';
import { ShortInfoActionProps } from './short-info-action';

type AllowedChildren = ReactElement<ShortInfoRentalStationSelectProps> | ReactElement<ProductPriceProps> | ReactElement<ShortInfoActionProps> | false | null;

export type IShortInfoProps = {
  children: AllowedChildren | Array<AllowedChildren>;
}

export const ShortInfo: FC<IShortInfoProps> = ({
  children
}) => {
  return (
    <div className={styles.shortInfoContainer}>
      <div className={classNames({
        [styles.contentContainer]: true,
        [styles.defaultContentType]: true
      })}>
        {children}
      </div>
    </div>
  );
};
